import { CarouselController } from "~/controllers/carousel_controller"

// Body-scroll lock and close are handled by the surrounding ModalComponent.
export default class extends CarouselController {
  options = {
    draggable: true,
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
    arrowShape: {
      x0: 15,
      x1: 65,
      y1: 50,
      x2: 70,
      y2: 50,
      x3: 20
    }
  }
}
